// @ts-nocheck
import type { RouterConfig } from "@nuxt/schema";

import i18nConfig from "@/i18n.config";

import {
	Survey,
	SurveyAudienceModule,
	SurveyEditorWrapper,
	SurveyResults,
	Surveys,
} from "@products/banza-survey-editor";

import {
	NavigationMenu,
	QuartzManagement,
	UsersModule,
} from "@products/base-portal-lib";

const _customRoutes = [
	/**
	 * AUTHORIZATION
	 */
	{
		name: "Sign In",
		path: "/signin",
		component: () => import("~/pages/admin/auth/signin.vue"),
		meta: {
			layout: "public",
		},
	},
	/**
	 * NAVIGATION MENU
	 */
	{
		name: "Navigation menu management",
		path: "/admin/NavigationMenu",
		component: NavigationMenu,
		props: () => ({ usePages: false }),
	},
	/**
	 * USERS
	 */
	{
		name: "Users",
		path: "/admin/users",
		component: UsersModule,
		meta: {
			sectionName: "Users management",
			isSection: true,
		},
	},
	/**
	 * SCHEDULER
	 */
	{
		name: "Scheduler",
		path: "/admin/scheduler",
		component: QuartzManagement,
		meta: {
			sectionName: "Scheduler",
			isSection: true,
		},
	},
	/**
	 * SURVEYS
	 */
	{
		path: "/survey/new",
		name: "Survey creator",
		component: SurveyEditorWrapper,
	},
	{
		path: "/survey/edit/:id?",
		name: "Survey editor",
		component: SurveyEditorWrapper,
		props: (route) => ({ id: route.params.id }),
	},
	{
		path: "/survey/edit/a/:id?",
		name: "Survey audience editor",
		component: SurveyAudienceModule,
		props: (route) => ({ surveyId: route.params.id }),
	},
	{
		path: "/survey/:id",
		name: "Survey",
		component: Survey,
		props: (route) => ({ id: route.params.id }),
		meta: {
			hideNavigator: true,
			layout: "public",
			fullScreen: true,
		},
	},
	{
		path: "/survey/a/:id",
		name: "Survey by audience",
		component: Survey,
		props: (route) => ({ audienceId: route.params.id }),
		meta: {
			hideNavigator: true,
			layout: "public",
			fullScreen: true,
		},
	},
	{
		path: "/surveys",
		name: "Survey list",
		// meta: {
		//   isSection: true,
		//   sectionName: 'Surveys',
		// },
		component: Surveys,
	},
	// {
	//   path: "/settings",
	//   name: "Survey settings",
	//   component: async () => await import("../views/SurveySettings.vue"),
	// },
	{
		path: "/surveyresults/:id",
		name: "Survey results",
		component: SurveyResults,
		props: (route) => ({ id: route.params.id }),
	},
];

const localizeRoute = (pathConfig) => {
	const { locales, defaultLocale } = i18nConfig;
	return locales.map(({ code: locale }) => {
		return locale !== defaultLocale
			? {
					...pathConfig,
					path: `/${locale}${pathConfig.path}`,
					name: `${pathConfig.name}___${locale}`,
					redirect: pathConfig?.redirect
						? `/${locale}${pathConfig.redirect}`
						: null,
			  }
			: {
					...pathConfig,
					// name: `${pathConfig.name}`,
					name: `${pathConfig.name}___${locale}`,
			  };
	});
};

const _localizedRoutes = _customRoutes.flatMap((route) => localizeRoute(route));

export default <RouterConfig>{
	routes: (_routes) => [..._routes, ..._localizedRoutes],
};
